<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t('AddNew'): $t('Update') }} PLAN</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">
        <!-- title -->
        <vs-input :label="$t('Title')" v-model="Title" class="mt-5 w-full" name="title"  v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>

         <!-- title -->
        <vs-input :label="$t('Description')" v-model="Description" class="mt-5 w-full" name="Description"   />
        <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>

        <!-- start date -->
        <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('StartDate')}}</label>
        <datepicker :format="format" :placeholder="$t('StartDate')" v-model="StartDate" input-class="mt-5 w-full" name="startDate" v-validate="'required'"></datepicker>
        <span class="text-danger text-sm" v-show="errors.has('startDate')">{{ errors.first('startDate') }}</span>

        <!-- End date -->
         <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('EndDate')}}</label>
        <datepicker :format="format" :placeholder="$t('EndDate')" v-model="EndDate" class="mt-5 w-full" name="endDate" v-validate="'required'"></datepicker>
        <span class="text-danger text-sm" v-show="errors.has('endDate')">{{ errors.first('endDate') }}</span>
    </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button  class="mr-6" @click="submitData" :disabled="!isFormValid||isConfirmed">{{$t('Submit')}}</vs-button>
      <vs-button type="border" color="danger" class="mr-6" @click="isSidebarActiveLocal = false" >{{$t('Cancel')}}</vs-button>
      <vs-button  color="danger"    @click="deleteEvent" v-if="ID" :disabled="isConfirmed">{{$t('Delete')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { ID, start, end, title, Description} = JSON.parse(
          JSON.stringify(this.data)
        );

        this.ID = ID;
        this.StartDate = start;
        this.EndDate = end;
        this.Title = title;
        this.Description=Description;
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.ID, this.Name, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },

  data() {
    return {
      itemsPerPage:5,
      ID: null,
      StartDate : null,
      EndDate : null,
      Title : null,
      Description: "",
      format:"dd-MM-yyyy",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");

        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.Title && this.StartDate && this.EndDate;
    },

  },

  methods: {
    initValues() {
      if (this.data.ID) return;
      this.ID = null;

      this.StartDate = null;
      this.EndDate = null;
      this.Title = null;
      this.Description= "";

    },

     deleteEvent() {
      this.$store.dispatch("holidayList/removeItem", this.ID).catch(err => {
        console.error(err);
      });
      this.deleteAlert();
     this.isSidebarActiveLocal = false;
    },



   openConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title:this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.deleteAlert
      });
    },


    deleteAlert() {
      //this.deleteEvent();
      this.$vs.notify({
        color: "danger",
        title:this.$t("Deletedrecord"),
         text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    confirmAlert()
    {
    this.$vs.notify({
        color: "success",
        title:this.$t("Confirmed")  ,
        text: this.$t("TheselectedEventwassuccessfullyConfirmed")
      });
    },

    getHolidayObj()
    {
          let obj = {
            ID: this.ID,
            StartDate: this.StartDate,
            EndDate: this.EndDate,

            start: this.StartDate,
            end: this.EndDate,
            title:this.Title,
            Description:this.Description,
            allDay:true
          };
          return obj;
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {

          const obj = this.getHolidayObj();
          debugger;
          if (this.ID !== null && this.ID >= 0) {
            this.$store.dispatch("holidayList/updateItem", obj).catch(err => {
              console.error(err);
            });
          } else {
            delete obj.ID;
            this.$store.dispatch("holidayList/addItem", obj).catch(err => {
              console.error(err);
            });
          }

          this.$emit("closeSidebar",obj);
          this.initValues();

        }
      });
    },


  },
  created(){

  },

  components: {
    VuePerfectScrollbar,
    Datepicker,
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.spacer{
    clear: both;
    height: 10px;
}
</style>
